var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 7.125C9.69137 7.125 11.0625 5.75387 11.0625 4.0625C11.0625 2.37113 9.69137 1 8 1C6.30863 1 4.9375 2.37113 4.9375 4.0625C4.9375 5.75387 6.30863 7.125 8 7.125Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.00001 11.9348C0.998843 11.594 1.06827 11.2574 1.20305 10.9505C1.626 10.0218 2.81872 9.52967 3.80843 9.3068C4.5222 9.13958 5.24584 9.02787 5.97394 8.97249C7.32197 8.8425 8.67779 8.8425 10.0258 8.97249C10.7539 9.02851 11.4775 9.14021 12.1913 9.3068C13.181 9.52967 14.3738 9.9754 14.7967 10.9505C15.0678 11.5762 15.0678 12.3027 14.7967 12.9284C14.3738 13.9035 13.181 14.3492 12.1913 14.5628C11.4784 14.7369 10.7545 14.8518 10.0258 14.9064C8.92863 15.0085 7.82632 15.0271 6.7268 14.9621C6.47302 14.9621 6.22771 14.9621 5.97394 14.9064C5.24799 14.8525 4.52686 14.7376 3.81689 14.5628C2.81872 14.3492 1.63446 13.9035 1.20305 12.9284C1.06895 12.6179 0.999601 12.2784 1.00001 11.9348Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.ce80ba858cc2501bf157d6da02e09056.svg";
export { ForwardRef as ReactComponent };